@if (isLoaded()) {
  <div class="shift-config-container">
    <h3>{{ 'SHIFT_CONFIG.TITLE' | translate }}</h3>

    <form (ngSubmit)="save()">
      <div class="form-group">
        <label for="shiftsPerDay">{{ 'SHIFT_CONFIG.SHIFTS_PER_DAY' | translate }}</label>
        <select
          id="shiftsPerDay"
          type="number"
          [ngModel]="formData.shiftsPerDay"
          (ngModelChange)="onShiftsPerDayChange($event)"
          name="shiftsPerDay"
          class="form-select"
        >
          @for (opt of shiftsOptions; track opt) {
            <option [ngValue]="opt">{{ opt }} &times; {{ 24 / opt }}h</option>
          }
        </select>
      </div>

      <div class="form-group">
        <label for="firstShiftStartHour">{{ 'SHIFT_CONFIG.FIRST_SHIFT_START' | translate }}</label>
        <input
          id="firstShiftStartHour"
          type="number"
          [(ngModel)]="formData.firstShiftStartHour"
          name="firstShiftStartHour"
          min="0"
          max="23"
          class="form-control"
          [class.is-invalid]="showError() && (formData.firstShiftStartHour < 0 || formData.firstShiftStartHour > 23)"
        />
        <div class="invalid-feedback">{{ 'SHIFT_CONFIG.HOUR_RANGE_ERROR' | translate }}</div>
      </div>

      <table class="shift-table">
        <thead>
          <tr>
            <th>{{ 'SHIFT_CONFIG.SHIFT' | translate }}</th>
            <th>{{ 'SHIFT_CONFIG.LABEL' | translate }}</th>
            <th>{{ 'SHIFT_CONFIG.START_HOUR' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (i of shiftIndices; track i) {
            <tr>
              <td>{{ i + 1 }}</td>
              <td>
                <input
                  type="text"
                  [(ngModel)]="formData.shiftLabels[i]"
                  [name]="'shiftLabel_' + i"
                  class="form-control"
                  [class.is-invalid]="showError() && !formData.shiftLabels[i]?.trim()"
                  required
                />
              </td>
              <td class="start-hour">{{ computedStartHour(i) | number:'2.0-0' }}:00</td>
            </tr>
          }
        </tbody>
      </table>

      <div class="form-actions">
        <button type="submit" class="btn btn-primary">
          {{ 'GLOBAL.VALIDER' | translate }}
        </button>
      </div>
    </form>
  </div>
}
